export const APPCONFIG_CONTRACT_VIEWER = 'contract_viewer';
export const APPCONFIG_CURRENCY_CODE = 'currency_code';
export const APPCONFIG_CSS_VARIABLES = 'css_variables';
export const APPCONFIG_DISABLE_FAQ_TAB = 'disable_faq_tab';
export const APPCONFIG_DISABLE_MEMBERSHIP_TAB = 'disable_membership_tab';
export const APPCONFIG_DISABLE_MEMBERSHIP_CANCELATION = 'disable_membership_cancelation';
export const APPCONFIG_DISABLE_MEMBERSHIP_PAY_OFF = 'disable_membership_pay_off';
export const APPCONFIG_DISPLAY_ZERO_CAPACITY = 'display_zero_capacity';
export const APPCONFIG_RECEIPTS = 'receipts';
export const APPCONFIG_PRIMARY_NAV_COLOR = 'primary_nav_color';
export const APPCONFIG_PRIMARY_NAV_COLOR_TEXT = 'primary_nav_text_color';
export const APPCONFIG_ENHANCED_PHONE_NUMBER = 'enhanced_phone_number';
export const APPCONFIG_ACCESSO_PAY = 'accessoPay';
export const APPCONFIG_LOGO = 'logo';
export const APPCONFIG_ASSET_PATH = 'assetsPath';
export const APPCONFIG_PAYMENT_HISTORY_FOOTER = 'show_payment_history_footer';
export const APPCONFIG_DISABLE_PAYMENT_HISTORY_TAB = 'disable_payment_history_tab';
export const APPCONFIG_DISABLE_PAYMENT_ID = 'disable_payment_id';
export const APPCONFIG_BOOKINGS = 'bookings';
export const APPCONFIG_PRINT_PATH = 'print_path';
export const APPCONFIG_REPRINT_MOBILE_LINK = 'reprint_mobile_link';
export const APPCONFIG_FAVICON_OVERRIDE = 'faviconOverride';
export const APPCONFIG_MERCHANT_LOCALE_SUFFIX = 'merchant_locale_suffix';
export const APPCONFIG_SUPPORT_NUMBER = 'supportNumber';
export const APPCONFIG_SUPPORTED_LANGUAGES = 'supported_languages';
export const APPCONFIG_MFA_RESEND_CODE_WAIT_TIME = 'mfa_resend_code_wait_time';
export const APPCONFIG_NAVIGATION_TREE_DISPLAY = 'navigation_tree_display';
export const APPCONFIG_SW_TICKET_USAGE_REFRESH_TIME = 'sw_ticket_usage_refresh_time';
